<script setup lang="ts">
/**
 * Deprecated button component
 * @deprecated Use PrimaryButton, SecondaryButton or TextButton instead
 */

interface Props {
  /** Whether the button is in loading state */
  loading?: boolean
  /** Whether the button is filled (primary) or not (secondary) */
  filled?: boolean
  /** Whether the button is disabled */
  disabled?: boolean
  /** Button type attribute */
  type?: HTMLButtonElement['type']
}

const { type = 'submit' } = defineProps<Props>()

defineOptions({
  name: 'BaseButton'
})
</script>

<template>
  <button
    class="button"
    :type
    :disabled="loading || disabled"
    :class="{
      secondary: !filled,
      'cursor-not-allowed': loading,
      loading
    }"
  >
    <slot>OK</slot>
  </button>
</template>
